import { useState, useEffect, useCallback } from "react";
import LoadingSpinner from "@/shared/components/LoadingSpinner/LoadingSpinner";

const LOADING_MESSAGES = [
  "Chargement de votre espace...",
  "R\u00e9cup\u00e9ration de vos donn\u00e9es...",
  "Mise en place de votre interface...",
  "Encore quelques instants...",
  "Presque pr\u00eat...",
] as const;

const MESSAGE_INTERVAL_MS = 2500;

const ContentLoadingScreen = () => {
  const [messageIndex, setMessageIndex] = useState(
    () => Math.floor(Math.random() * LOADING_MESSAGES.length),
  );

  const cycleMessage = useCallback(() => {
    setMessageIndex((prev) => {
      let next: number;
      do {
        next = Math.floor(Math.random() * LOADING_MESSAGES.length);
      } while (next === prev);
      return next;
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(cycleMessage, MESSAGE_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [cycleMessage]);

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4">
      <LoadingSpinner size="xl" variant="primary" />
      <p
        key={messageIndex}
        className="animate-in fade-in text-muted-foreground text-sm italic duration-500"
      >
        {LOADING_MESSAGES[messageIndex]}
      </p>
    </div>
  );
};

export default ContentLoadingScreen;
